import Axios from "axios";
import store from "@/store";
import router from "@/router";

const api = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { "X-Tenant-ID": process.env.VUE_APP_X_TENANT_ID },
  timeout: 0,
});

const authApi = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { "X-Tenant-ID": process.env.VUE_APP_X_TENANT_ID },
  timeout: 20000,
});

// interceptor request
api.interceptors.request.use(
  (config) => {
    const token = store.getters.accessToken;

    if (token) config.headers.Authorization = store.getters.accessToken;

    return config;
  },
  (error) => Promise.reject(error)
);

const responseFailed = (err) => {
  // unauthorized
  if ([401].includes(err?.response?.status) && !!store.getters.accessToken) {
    const refreshToken = store.getters.refreshToken;

    // previne infinity sign-out requests
    const ignoredRoutes = ["/auth"];
    const isIgnoredRoute = ignoredRoutes.includes(err.config.url);
    const isLoadSessionRoute = isIgnoredRoute && err.config.method === "get";

    if ((isIgnoredRoute && !isLoadSessionRoute) || !refreshToken)
      return signOutLocal(err);

    // try RefreshToken and resend request
    return authApi
      .put("/auth/refresh", { refreshToken })
      .then(({ data }) => {
        store.dispatch("setAccessToken", data.accessToken);
        store.dispatch("setRefreshToken", data.refreshToken);

        err.config.headers.Authorization = data.accessToken;

        return Axios(err.config);
      })
      .catch(() => signOutLocal(err));
  }

  return Promise.reject(err.response?.data || err.response);
};

function signOutLocal(err) {
  store.dispatch("setSignOut");
  router.push({ path: "/auth" }).catch(() => {
    /* ignore */
  });
  return Promise.reject(err);
}

// interceptor
api.interceptors.response.use(
  (res) => Promise.resolve(res),
  (err) => responseFailed(err)
);

export default api;
